import { portalJson } from '../lib/portalApi';
import { setPortalSession } from '../lib/portalSession';

export type PortalLoginOk = { token: string; account: string; role: string };

export async function portalLogin(login: string, password: string): Promise<PortalLoginOk> {
  const r = await portalJson<PortalLoginOk>('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ login, password }),
  });
  if (!r.ok) {
    throw new Error(r.message);
  }
  const d = r.data;
  if (!d.token || !d.account) {
    throw new Error('서버 응답 형식이 올바르지 않습니다.');
  }
  setPortalSession(d.token, d.account, d.role);
  return d;
}
